import { render, staticRenderFns } from "./msgListButtonWise.vue?vue&type=template&id=9b75770c&scoped=true&"
import script from "./msgListButtonWise.vue?vue&type=script&lang=js&"
export * from "./msgListButtonWise.vue?vue&type=script&lang=js&"
import style0 from "./msgListButtonWise.vue?vue&type=style&index=0&id=9b75770c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b75770c",
  null
  
)

export default component.exports